module.exports = __webpack_public_path__ + "static/img/class-room-recording3.a05037b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/class-room-recording3.jpg
// module id = +WC0
// module chunks = 1